// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-item.item {
  --border-width: 1px;
  --border-color: var(--ion-color-light);
  --border-radius: 10px;
}
:host ion-button {
  --background: var(--cms-button-bg-color);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login-pages/login-rescue-password/login-rescue-password.scss"],"names":[],"mappings":"AAIM;EACE,mBAAA;EACA,sCAAA;EACA,qBAAA;AAHR;AAQI;EACE,wCAAA;AANN","sourcesContent":[":host{\n  ion-item{\n\n        \n      &.item{\n        --border-width: 1px;\n        --border-color: var(--ion-color-light);\n        --border-radius: 10px;\n      }\n\n    }\n\n    ion-button{\n      --background: var(--cms-button-bg-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
